import React from 'react';

const Page = React.lazy(() => import('./BillingSummaryReportPage'));

const BillingSummaryReportConfig = {
	settings: { layout: { config: {} } },
	routes: [
		{
			path: '/billing/reports/summary',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Page />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default BillingSummaryReportConfig;
